import React, {useEffect, useState} from "react";
import PaymentInfoConfirm from "../payment/info-confirm";
import {useLoading} from "../../components/loading/LoadingProvider";
import {forAuthentication, postTradesPayment, postTradesSubmit} from "../../service";
import {useHistory} from "react-router-dom";
import {stringify} from "qs";
import useUserInfo from "../../routers/useUserInfo";
import {useParams} from "react-router-dom";
import {useModal} from "../../components/modal";
import Steps from "../../components/steps";
import {priceConvert} from "../../units";
import {CouponModal} from "../user/doPay";
import {CouponItem} from "../../components/coupon";
import {GradesVisibleData} from "../types";
import { calcPrice } from "../user/doPay";

function getIsWxClient() {
    const ua = navigator.userAgent.toLowerCase();
    // @ts-ignore
    if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true;
    }
    return false;
}

const lists = ['完善信息','确认订单']


function AuthoritiesWithInfoConfirm() {
    const loading = useLoading()
    const { id } = useParams<{ id: string}>()
    const userDta = useUserInfo(false)
    const modal = useModal()
    const { goBack,replace } = useHistory()
    const [active,setActive] = useState(0)
    const [modalShow, setShow] = useState(false)
    const [coupon, setCoupon] = useState<CouponItem | null>(null)
    const [summary, setSummary] = useState<GradesVisibleData>()

    const modalHandle = (data: CouponItem | boolean) => {
        if (typeof data !== 'boolean') {
            setCoupon(data)
        }
        setShow(false)
    }

    const doPayHandle = () => {

        if (id && userDta) {
            loading.showLoading('支付中')
            postTradesSubmit({
                userId: userDta.id,
                orderId: id,
                couponId: coupon?.id
            }).then(res => {
                loading.hideLoading()

                if (res.code === 1) {
                    if (res.data.payType === 2) {

                        const url = res.data.mwebUrl + `&redirect_url=${encodeURIComponent('http://www.tibavip.com/wx'  + '?userId='+ userDta.id +'&tradeId=' + res.data.id)}`

                        if (!getIsWxClient()) {
                            window.location.href = url
                        } else {
                            replace(`/doWxPay?${stringify({
                                url,
                            })}`)
                        }
                    } else {
                        loading.showLoading()
                        postTradesPayment({
                            tradeId: res.data.id,
                            userId: userDta.id
                        }).then(res => {
                            if (res.code === 1) {
                                loading.showSuccess('支付成功', () => {
                                    goBack()
                                })
                            }else{
                                modal.show({
                                    content:res.msg,
                                    showCancel:false,
                                    success(){
                                        goBack()
                                    }
                                })
                            }
                        })
                    }
                }else{
                    modal.show({
                        content:res.msg,
                        showCancel:false,
                        success(){
                            goBack()
                        }
                    })
                }
            })
        }else{
            modal.show({
                content:'无效订单',
                showCancel:false,
                success(){
                    goBack()
                }
            })
        }
    }

    useEffect(() => {
        if(active === 1){
            loading.showLoading()
            forAuthentication().then(res => {
                if (res.code === 1) {
                    loading.hideLoading()
                    setSummary(res.data)
                }else{
                    loading.showError(res.msg)
                }
            })
        }

    }, [active])


    return <div className="a-with-c">
        <Steps lists={lists} active={active}/>
        {
            active === 0 && <PaymentInfoConfirm onSuccess={ () => setActive(1) }/>
        }
        {
            active === 1 && <div className="doPay">
                <div className="choose-coupon" onClick={() => setShow(true)}>
                    <div className='common-input-box'>
                        <div className="common-input-item">
                            <div className="_left">
                                <p className="name"><span className="iconfont">&#xe607;</span> 卡券</p>
                                <p className="placeholder">{coupon?.couponName || "选择优惠券"}</p>
                            </div>
                            <div className="_right">
                                <p className="iconfont">&#xe608;</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pay-box">
                    <ul>
                        <li>
                            <p className="t">支付金额</p>
                            <p className="v">￥{priceConvert(summary?.annualFee)}</p>
                        </li>
                        <li>
                            <p className="t">优惠券</p>
                            <p className="v">{coupon ? `-￥ ${priceConvert(coupon.couponAmount)}` : '未使用优惠券'}</p>
                        </li>
                    </ul>

                    {
                        summary &&
                        <div className="common-btn"
                             onClick={doPayHandle}>确认支付 {calcPrice(summary.annualFee, coupon?.couponAmount || 0)}元</div>
                    }

                </div>
                <CouponModal orderId={ id } onclose={(data) => modalHandle(data)} show={modalShow}/>
            </div>
        }
    </div>
}

export default AuthoritiesWithInfoConfirm
